export default "__VITE_ASSET__b546a86f__"